module.exports = __webpack_public_path__ + "static/img/Mcgrath.499dde15.jpeg";